export const en = {
    select_all_airlines: 'Select all airlines',
};
